import { Ref } from "vue"

export function updateWhere<T>(
  list: Ref<T[]>,
  where: (item: T) => boolean,
  update: (item: T) => T
) {
  const index = list.value.findIndex(where)
  if (index >= 0) {
    list.value[index] = update(list.value[index])
  }
  return index >= 0
}

export function removeWhere<T>(list: Ref<T[]>, where: (item: T) => boolean) {
  const originalLength = list.value.length
  list.value = list.value.filter((item) => !where(item))
  return list.value.length !== originalLength
}
